module.exports = __webpack_public_path__ + "262100cfddd6319e060e43458510191f.png";